const menuBtn   = document.querySelector('.toggle-menu');
const menu      = document.querySelector('.site-navigation');

menuBtn.addEventListener( 'click', function() {
	menu.classList.toggle('menu-open');
} );

jQuery(function($) {
	$('.menu-button').on('click', function (e) {

		e.preventDefault();

		$(this).parent().find('.sub-menu').toggleClass('submenu-open');

	});
});
